import { useState, useEffect } from 'react'
//import { frontPage } from "../data/data"
import { Link, useParams, useNavigate, useLocation } from 'react-router';
import Store from '../Store/Store';
import Request from '../Request/Request';

//import Landing from "../Page/Landing"
import Content from "../Page/Content"
//import Center from "../App/Center"

export default function Page( props ) {

	const user = Store.get( 'user' )
	const location = useLocation()
	const path = location.pathname
	const { cruiseId } = useParams();
	const cruise = cruiseId && props.cruises.hasOwnProperty( cruiseId ) && props.cruises[ cruiseId ]
	const [ sessionValid, setSessionValid ] = useState( false )

	//if ( cruiseId ) console.log( cruiseId, cruise, props.cruises )

	useEffect(() => {
		if ( user && user.token ) {
			Request.get( 'token', d => {
				setSessionValid( d.data.token )
				if ( !d.data.token ) Store.set( 'user', null )
			} )
		}
	}, [] )

	useEffect(() => {
		window.scrollTo( { top:0, left:0 } )
	}, [ cruiseId, path ]);

	//console.log( props.content.hasOwnProperty( props.pageId ), props.pageId, props.content[ props.pageId ] )

	if ( !props.content.hasOwnProperty( props.pageId ) ) return false	

	const data = props.content[ props.pageId ].rows

	return <>

	    <Content 
	    	categories={ props.categories } 
	    	data={ data } 
	    	sessionValid={ sessionValid }
	    	cruise={ cruise }
	    	cruiseId={ cruiseId }
    	/>

	</>

}

